module.exports = __webpack_public_path__ + "img/light_ic_screen_portrait.80c4cba5.png";